/* eslint-disable no-mixed-spaces-and-tabs,no-param-reassign,no-tabs */
import { COMPONENTS } from '../../../app/constants/components';

xplenty.directive('componentIcon', [
  function () {
    return {
      templateNamespace: 'svg',

      restrict: 'E',

      template: '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" href="{{getIconHref()}}"></use></svg>',

      replace: true,

      scope: {
        type: '=ngModel',
      },

      link(scope, element, attrs) {
        if (!scope.type || scope.type === '') {
          element.remove();
          return;
        }

        const size = attrs.size || 32;

        element[0].setAttribute('width', size);
        element[0].setAttribute('height', size);

        scope.getIconHref = function () {
          return `#icons-sprite_${COMPONENTS[scope.type].icon}`;
        };
      },
    };
  },
]);
